import React, { useState, useEffect } from 'react'
import './VisualProgram.css'
import { Link, useHistory } from 'react-router-dom'
import cacheAssets from '../../../utils/cacheAssets'
import packageJson from '../../../../package.json'
import renderPrgImage from '../../../source/programImg'
import VisualPrgm from '../../ReusableComponents/PrgmSlider/VisualPrgm/VisualPrgm'
import MainHeader from '../../ReusableComponents/Header/MainHeader'
import { generateDeviceDataKey } from '../../ReusableComponents/ByteTransfer/utils'
import { connect } from 'react-redux'
import { languageWords } from '../../../utils/langaugeSupport'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import FeatureGate from '../../ReusableComponents/FeatureGate'
import {
    isCodingFeatureEnabled,
    brandDeviceKeyFromDataKey,
} from '../../../hooks/useBrandConfig'
import { isDesktopApp } from '../../../helpers/platform'
import deviceVersionObj from '../../../deviceVersion.json'
const currentDomain = window.location.origin
const blockBasedBase = isDesktopApp()
    ? 'http://localhost:3123/scratch'
    : /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(currentDomain)
      ? 'http://localhost:8601/'
      : `${currentDomain}/blockbased/`
let domain = blockBasedBase
// device query param and fallback version per device data key; the version
// actually sent is the firmware version of the connected device when known
const blockBaseDevices = {
    ACE0: { device: 'peeCee', version: '1.1.0' },
    ACE1: { device: 'peeCee', version: '1.1.0' },
    HUMANOID0: { device: 'zing', version: '1.0.0' },
    HUMANOID1: { device: 'zing', version: '1.0.0' },
    HUMANOID2: { device: 'zing', version: '1.0.0' },
    HUMANOID3: { device: 'zing', version: '1.0.0' },
    HEXAPOD1: { device: 'crawle', version: '1.0.0' },
    HEXAPOD2: { device: 'crawle', version: '1.0.0' },
    HEXAPOD3: { device: 'crawle', version: '1.0.0' },
    ROBOKI1: { device: 'roboki', version: '1.0.0' },
}

// key of the device in the firmware version list
const firmwareListName = {
    peeCee: 'playcomputer',
    zing: 'zing',
    crawle: 'crawlee',
    roboki: 'roboki',
}

// latest published firmware (x.y.z) for the device within the fallback
// version's major series, e.g. peeCee 1.x -> 1.1.12
const getLatestFirmwareVersion = (entry) => {
    let versionData = deviceVersionObj
    try {
        versionData =
            JSON.parse(sessionStorage.getItem('versionData')) || versionData
    } catch (e) {}
    const branches = versionData?.[firmwareListName[entry.device]]
    if (!branches) return null
    const toNums = (v) => v.split('.').map(Number)
    const major = entry.version.split('.')[0]
    let latest = null
    for (const branch of Object.values(branches)) {
        const v = branch?.version
        if (!v || v.split('.')[0] !== major) continue
        if (!latest) {
            latest = v
            continue
        }
        const a = toNums(v)
        const b = toNums(latest)
        for (let i = 0; i < Math.max(a.length, b.length); i++) {
            if ((a[i] || 0) !== (b[i] || 0)) {
                if ((a[i] || 0) > (b[i] || 0)) latest = v
                break
            }
        }
    }
    return latest ? latest.split('.').slice(0, 3).join('.') : null
}

// connected device version -> else latest firmware -> else hardcoded default
const getBlockBaseLink = (key, connectedVersion) => {
    const entry = blockBaseDevices[key]
    if (!entry) return undefined
    const version = /^\d+\.\d+\.\d+/.test(connectedVersion || '')
        ? connectedVersion.split('.').slice(0, 3).join('.')
        : getLatestFirmwareVersion(entry) || entry.version
    return `${domain}?device=${entry.device}&version=${version}`
}

const syncPeeCeeSensorToEditor = (key) => {
    if (blockBaseDevices[key]?.device !== 'peeCee') return
    const allowed = sessionStorage.getItem('allowedPeeCeeVariant')
    const sensor =
        allowed === 'ted2' || allowed === 'ted1'
            ? allowed.slice(-1)
            : sessionStorage.getItem('peeCeeConfVersion')
    if (sensor === '1' || sensor === '2') {
        document.cookie = `peeCeeLaunchVariant=${sensor}; path=/; max-age=120`
    }
}

function VisualProgram(props) {
    const version = sessionStorage.getItem('deviceVersion')
    const device = sessionStorage.getItem('connectedDevice')
    const languageName = props.device.language
    const [showDialogModal, setShowDialogModal] = useState({
        show: false,
        link: '',
        text1: '',
        text2: '',
        text3: '',
    })
    const [show_tost_text, setShow_tost_text] = useState({
        isShow: false,
        text: '',
    })
    // const [isShow_comingSoon_text, setIsShow_comingSoon_text] = useState(false)
    // const [isShow_cServerDown_text, setIsShow_cServerDown_text] =
    //     useState(false)
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const brandDeviceKey = brandDeviceKeyFromDataKey(
        generateDeviceDataKey(connectedDevice, deviceVersion || '1')
    )
    const isCustomCodeFlashed =
        localStorage.getItem('customCodeFlashed') === 'true'
    const isMicroPythonFlashed =
        localStorage.getItem('microPythonFlashed') === 'true'
    const isNonStandardFirmware = isCustomCodeFlashed || isMicroPythonFlashed
    const [showCustomFirmwarePrompt, setShowCustomFirmwarePrompt] =
        useState(false)
    const [pendingNavigation, setPendingNavigation] = useState(null)
    const customFirmwareTooltip = isNonStandardFirmware
        ? 'Non-standard firmware detected. Click to flash original firmware.'
        : undefined
    const item1Styl = {
        backgroundImage: `url("${renderPrgImage(
            'flowchartbasedgroupbutton'
        )}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        pointerEvents: 'all',
        cursor: 'pointer',
        opacity:
            [
                'Hexapod',
                'Roboki',
                'Klaw',
                'Atr',
                'Toki',
                'Poki',
                'Moki',
                'Autoki',
                'woofKit',
            ].includes(device) ||
            (device === 'Humanoid' && ['3'].includes(deviceVersion?.[0]))
                ? 0.5
                : 1,

        // cursor: ['Hexapod', 'Roboki'].includes(device) ? 'default' : 'pointer',
    }
    const item2Styl = {
        backgroundImage: `url("${renderPrgImage('projectbased')}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        pointerEvents: 'all',
        cursor: 'pointer',
        opacity: 1,
    }
    const item3Styl = {
        backgroundImage: `url("${renderPrgImage('blockbased')}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        pointerEvents: 'all',
        cursor: 'pointer',
        opacity:
            [
                'Klaw',
                'Atr',
                'Toki',
                'Poki',
                'Moki',
                'Autoki',
                'woofKit',
            ].includes(device) ||
            (device === 'Hexapod' && ['2', '3'].includes(deviceVersion?.[0])) ||
            (device === 'Humanoid' && ['3'].includes(deviceVersion?.[0]))
                ? 0.5
                : 1,
    }
    const item4Styl = {
        backgroundImage: `url("${renderPrgImage('Cgroupbutton')}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        cursor: isMicroPythonFlashed
            ? 'pointer'
            : (version?.startsWith('0') && device === 'Ace') ||
                ['toki', 'Toki', 'Autoki'].includes(device)
              ? 'default'
              : 'pointer',
        opacity:
            isMicroPythonFlashed ||
            ['toki', 'Toki', 'Autoki'].includes(device) ||
            (version?.startsWith('0') && device === 'Ace')
                ? '0.5'
                : '1',
    }
    const item5Styl = {
        backgroundImage: `url("${renderPrgImage('pythoncodingbutton')}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        cursor: [
            'Ace',
            'Humanoid',
            'Hexapod',
            'Klaw',
            'Toki',
            'Poki',
            'woofKit',
        ].includes(device)
            ? 'pointer'
            : 'default',
        opacity: ![
            'Ace',
            'Humanoid',
            'Hexapod',
            'Klaw',
            'toki',
            'woofKit',
        ].includes(device)
            ? 0.5
            : 1,
    }
    const [isHelp, setHelp] = useState(false)

    const handleHelpBtn = (e) => {
        if (isHelp == true) {
            setHelp(false)
        } else {
            setHelp(true)
        }
    }

    //set the dialogModel for microPython firmware present
    const handelShowDialogModel = (link) => {
        setShowDialogModal({
            show: true,
            link: link, //blockBaseLink[blockBaseLinkKey],
            text1: `This feature is not supported for the Micropython firmware.`,
            text2: `If you want to experience the full capabilities of this feature, please upload the latest device specific Plode firmware from `,
            text3: 'Do you still wish to continue?',
        })
    }

    const handleDisabledClick = () => {
        setShow_tost_text({
            isShow: true,
            text: 'The feature is not currently available for this device. Coming soon...',
        })
        setTimeout(
            () =>
                setShow_tost_text({
                    isShow: false,
                    text: '',
                }),
            2000
        )
    }

    function blockbasedbtn() {
        if (device === 'woofKit') {
            sessionStorage.removeItem('slideDirection')
            window.location.assign(`${blockBasedBase}?device=poki&type=woofkit`)
            return
        }
        const microPython = sessionStorage.getItem('microPython')
        const proceed = () => {
            if (
                ['Klaw', 'Atr', 'Toki', 'Poki', 'Moki', 'Autoki'].includes(
                    device
                ) ||
                (device === 'Hexapod' &&
                    ['2', '3'].includes(deviceVersion?.[0])) ||
                (device === 'Humanoid' && ['3'].includes(deviceVersion?.[0]))
            ) {
                setShow_tost_text({
                    isShow: true,
                    text: ' The feature is not currently available for this device.Coming soon...',
                })
                setTimeout(
                    () => setShow_tost_text({ isShow: false, text: '' }),
                    2000
                )
                return
            }
            const blockBaseLinkKey = generateDeviceDataKey(
                connectedDevice,
                deviceVersion
            )
            syncPeeCeeSensorToEditor(blockBaseLinkKey)
            let assignLink = getBlockBaseLink(blockBaseLinkKey, deviceVersion)
            if (microPython == 'true') {
                handelShowDialogModel(assignLink)
                return
            }
            sessionStorage.removeItem('slideDirection')
            window.location.assign(assignLink)
        }
        if (isNonStandardFirmware && props.webSerial.isConnected) {
            setPendingNavigation(() => proceed)
            setShowCustomFirmwarePrompt(true)
            return
        }
        proceed()
    }

    const projectBaseHandelClick = () => {
        const microPython = sessionStorage.getItem('microPython')
        const proceed = () => {
            if (microPython == 'true') {
                handelShowDialogModel('/code/project')
                return
            }
            sessionStorage.removeItem('slideDirection')
            sessionStorage.setItem('programMode', 'projectBased')
            window.location.href = '/code/project'
        }
        if (isNonStandardFirmware && props.webSerial.isConnected) {
            setPendingNavigation(() => proceed)
            setShowCustomFirmwarePrompt(true)
            return
        }
        sessionStorage.removeItem('slideDirection')
        sessionStorage.setItem('programMode', 'projectBased')
        history.push('/code/project')
        // history.push('/code/project')
        // window.location.reload()
    }
    const pythonCodeClickHandel = () => {
        const proceed = () => {
            let microPython = sessionStorage.getItem('microPython')
            if (connectedDevice === 'Ace' && version?.startsWith('0')) {
                mycroPythonLink = 'http://micropython.plode.org'
            }
            if (!microPython || microPython == 'false') {
                setShowDialogModal({
                    show: true,
                    link: mycroPythonLink,
                    text1: `Python Coding is not supported for the Plode firmware.`,
                    text2: `If you want to experience the full capabilities of Python, please upload the device specific Micropython firmware or click "Flash MicroPython" to auto-update.`,
                    text3: 'Do you still wish to continue without MicroPython?',
                    isMicroPythonPrompt: true,
                })
                return
            }
            sessionStorage.removeItem('slideDirection')
            window.location.assign(mycroPythonLink)
        }
        if (isCustomCodeFlashed && props.webSerial.isConnected) {
            setPendingNavigation(() => proceed)
            setShowCustomFirmwarePrompt(true)
            return
        }
        proceed()
    }

    const handelFlowChartClick = () => {
        const microPython = sessionStorage.getItem('microPython')
        const proceed = () => {
            if (
                [
                    'Klaw',
                    'Roboki',
                    'Hexapod',
                    'Atr',
                    'Toki',
                    'Poki',
                    'Moki',
                    'Autoki',
                    'woofKit',
                ].includes(connectedDevice) ||
                (device === 'Humanoid' && ['3'].includes(deviceVersion?.[0]))
            ) {
                setShow_tost_text({
                    isShow: true,
                    text: ' The feature is not currently available for this device.Coming soon...',
                })
                setTimeout(
                    () => setShow_tost_text({ isShow: false, text: '' }),
                    2000
                )
                return
            }
            if (microPython == 'true') {
                handelShowDialogModel('/flow')
                return
            }
            sessionStorage.removeItem('slideDirection')
            sessionStorage.setItem('programMode', 'flowchartBased')
            window.location.href = '/flow'
        }
        if (isNonStandardFirmware && props.webSerial.isConnected) {
            setPendingNavigation(() => proceed)
            setShowCustomFirmwarePrompt(true)
            return
        }

        sessionStorage.removeItem('slideDirection')
        sessionStorage.setItem('programMode', 'flowchartBased')
        // history.push('/flow')
        // window.location.reload()
        history.push('/flow')
    }
    const handlePythonClick = (e) => {
        if (e) e.preventDefault() // Prevents default link behavior

        // 1. Logic for specific devices that use pythonCodeClickHandel
        if (['Ace', 'Humanoid', 'Hexapod', 'Klaw', 'Moki'].includes(device)) {
            pythonCodeClickHandel()
            return
        }

        // 2. Logic for devices that show "Coming soon..."
        if (['Atr', 'Roboki', 'Toki', 'Poki'].includes(connectedDevice)) {
            setShow_tost_text({
                isShow: true,
                text: ' The feature is not currently available for this device. Coming soon...',
            })
            setTimeout(() => {
                setShow_tost_text({
                    isShow: false,
                    text: '',
                })
            }, 2000)
            return
        }

        // 3. Default logic (redirect to micropython)
        sessionStorage.removeItem('slideDirection')
        window.location.assign('http://micropython.plode.org')
    }
    const handelCcodingClick = () => {
        if (isMicroPythonFlashed && props.webSerial.isConnected) {
            setPendingNavigation(() => () => {
                const microPython = sessionStorage.getItem('microPython')
                sessionStorage.removeItem('slideDirection')
                window.location.href = '/cCoding'
            })
            setShowCustomFirmwarePrompt(true)
            return
        }
        const microPython = sessionStorage.getItem('microPython')
        if (
            ['toki', 'Toki', 'Autoki'].includes(connectedDevice) ||
            (version?.startsWith('0') && connectedDevice === 'Ace')
        ) {
            setShow_tost_text({
                isShow: true,
                text: ' The feature is not currently available for this device.Coming soon...',
            })
            setTimeout(
                () =>
                    setShow_tost_text({
                        isShow: false,
                        text: '',
                    }),
                2000
            )
            return
        }

        // if (!localStorage.getItem('accessToken')) {
        //     setShow_tost_text({
        //         isShow: true,
        //         text: 'C server is down now.',
        //     })

        //     setTimeout(
        //         () =>
        //             setShow_tost_text({
        //                 isShow: false,
        //                 text: '',
        //             }),
        //         2000
        //     )
        //     return
        // }

        if (microPython == 'true') {
            const domain = window.location.origin
            handelShowDialogModel(
                `${isDesktopApp() ? 'http://localhost:3123' : 'https://edu.plode.org'}/scripting?language=c&device=` +
                    device.toLowerCase()
            )
            return
        }

        // if (!localStorage.getItem('accessToken')) {
        //     setShow_tost_text({
        //         isShow: true,
        //         text: 'C server is down now.',
        //     })
        //     setTimeout(
        //         () =>
        //             setShow_tost_text({
        //                 isShow: false,
        //                 text: '',
        //             }),
        //         2000
        //     )
        //     return
        // }
        const deviceMap = {
            Ace: version?.startsWith('1') ? 'peeCee' : 'peeCee',
            Humanoid: 'zing',
            Hexapod: 'crawle',
            Toki: 'toki',
            'Toki+': 'toki',
            Klaw: 'klawb',
            Poki: 'poki',
        }

        const mappedDevice = deviceMap[device] || device

        sessionStorage.removeItem('slideDirection')
        const domain = window.location.origin
        window.location.assign(
            `${isDesktopApp() ? 'http://localhost:3123' : 'https://edu.plode.org'}/scripting?language=c&device=` +
                mappedDevice.toLowerCase()
        )
    }

    const downloadSoftware = () => {
        sessionStorage.removeItem('slideDirection')
        const download = setTimeout(() => {
            if (
                JSON.parse(sessionStorage.getItem('isWindowOnFocus')) === true
            ) {
                const a = document.createElement('a')
                a.href = 'https://downloads.plode.org/zingFirmwareTool.exe'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                clearTimeout(download)
            }
        }, 500)
    }

    const history = useHistory()

    // Caching Internal Components assets

    useEffect(() => {
        let assetsToBeCached = [
            renderPrgImage('newfilegroupbutton'),
            renderPrgImage('yourprojectsgroupbutton'),
            renderPrgImage('newactiongroupbutton'),
            renderPrgImage('youractiongroupbutton'),
        ]
        cacheAssets(assetsToBeCached)
    }, [])

    const handlePythonPopup = () => {
        let ele = document.getElementById('popup-text')
        ele.className = 'show'
        console.log('python click', ele)
        setTimeout(function () {
            ele.className = ele.className.replace('show', '')
        }, 3000)
    }

    // let mycroPythonLink =
    //     sessionStorage.getItem('connectedDevice') === 'Ace' &&
    //     version?.startsWith('1')
    //         ? 'https://edu.plode.org/python/?device=peecee'
    //         : sessionStorage.getItem('connectedDevice') === 'Humanoid'
    //         ? 'https://edu.plode.org/python/?device=zing'
    //         : 'https://edu.plode.org/python/?device=roboki'
    let baseUrl = window?.location?.origin
    baseUrl =
        baseUrl && !baseUrl.includes('localhost')
            ? baseUrl
            : `${isDesktopApp() ? 'http://localhost:3123' : 'https://edu.plode.org'}`
    const deviceMap = {
        Ace: version?.startsWith('1') ? 'peeCee' : null,
        Humanoid: 'zing',
        Hexapod: 'crawle',
        Klaw: 'klawb',
        Moki: 'moki',
    }
    let mycroPythonLink =
        baseUrl +
        '/scripting?language=python&device=' +
        (deviceMap[connectedDevice] || 'peeCee')

    //in open the file, dialog model shows option generat
    const dialogModelOption = () => {
        let optionArr = []

        if (showDialogModal.isMicroPythonPrompt) {
            optionArr.push({
                text: 'Flash MicroPython',
                do: () => {
                    setShowDialogModal({
                        show: false,
                        link: '',
                        text1: '',
                        text2: '',
                        text3: '',
                    })
                    localStorage.setItem('microPythonUpdateConsent', 'true')
                    history.push('/deviceSelection')
                },
            })
        }

        optionArr.push({
            text: 'YES',
            do: () => {
                sessionStorage.removeItem('slideDirection')

                if (showDialogModal.link == '/code/project') {
                    history.push(showDialogModal.link)
                    sessionStorage.setItem('programMode', 'projectBased')
                    window.location.reload()
                } else if (showDialogModal.link == '/flow') {
                    history.push(showDialogModal.link)
                    sessionStorage.setItem('programMode', 'flowchartBased')
                    window.location.reload()
                } else {
                    window.location.assign(showDialogModal.link)
                }
            },
        })

        optionArr.push({
            text: 'NO',
            do: () => {
                setShowDialogModal({
                    show: false,
                    link: '',
                    text1: '',
                    text2: '',
                    text3: '',
                })
            },
        })
        return optionArr
    }

    const getBlockBaseStyle = () => {
        if (
            ['Klaw', 'Atr', 'Toki', 'Toki+', 'Moki'].includes(device) ||
            (device === 'Hexapod' && ['2', '3'].includes(deviceVersion?.[0])) ||
            (device === 'Humanoid' && ['3'].includes(deviceVersion?.[0]))
        ) {
            return { cursor: 'default' }
        } else {
            return { cursor: 'pointer' }
        }
    }
    const getFlowChartStyle = () => {
        if (
            [
                'Hexapod',
                'Roboki',
                'Klaw',
                'Atr',
                'Toki',
                'Toki+',
                'Moki',
            ].includes(device) ||
            (device === 'Humanoid' && ['3'].includes(deviceVersion?.[0]))
        ) {
            return { cursor: 'default' }
        } else {
            return { cursor: 'pointer' }
        }
    }

    return (
        <>
            <div className="visualProgram-container">
                {/* <img
                    src={renderPrgImage('backBtn')}
                    className="iconBtnSize VP-backbtn"
                    onClick={() => {
                        history.push('/Selection')
                    }}
                />
                {isHelp == false ? (
                    <img
                        className="iconBtnSize helpiconBtnSize"
                        src={renderPrgImage('helpBtnInActive')}
                        style={{ marginRight: '25%' }}
                        onClick={handleHelpBtn}
                    ></img>
                ) : (
                    <div className="S_slide">
                        {' '}
                        <VisualPrgm />{' '}
                    </div>
                )}
                {isHelp ? (
                    <img
                        className="helpClose"
                        src={renderPrgImage('closBtn')}
                        onClick={handleHelpBtn}
                    ></img>
                ) : null}

                <img
                    src={renderPrgImage('programmenucard')}
                    className="VP-programmenucard"
                /> */}
                <DialogModal
                    show={showDialogModal.show}
                    text={
                        <>
                            <p>{showDialogModal.text1}</p>
                            <p>
                                {showDialogModal.text2}
                                <a
                                    href="https://firmware.plode.org"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {'here.'}
                                </a>
                            </p>

                            <p>{showDialogModal.text3}</p>
                        </>
                    }
                    showCloseBtn={false}
                    optionsToSelect={dialogModelOption()}
                />
                <DialogModal
                    show={showCustomFirmwarePrompt}
                    text={
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '0.5rem',
                            }}
                        >
                            <p
                                style={{
                                    fontSize: '2.2vh',
                                    fontWeight: 'bold',
                                }}
                            >
                                Non-Standard Firmware Detected
                            </p>
                            <p
                                style={{
                                    fontSize: '1.8vh',
                                    textAlign: 'center',
                                }}
                            >
                                {isMicroPythonFlashed
                                    ? 'This device is running MicroPython firmware. This feature requires the original firmware.'
                                    : 'It looks like custom firmware is running on your device. This feature requires the original firmware.'}
                            </p>
                            {isMicroPythonFlashed && (
                                <div
                                    style={{
                                        fontSize: '1.6vh',
                                        textAlign: 'center',
                                        background: '#FFF3E0',
                                        borderRadius: '8px',
                                        padding: '0.5rem 0.8rem',
                                        marginTop: '0.3rem',
                                        color: '#E65100',
                                        lineHeight: '1.5',
                                    }}
                                >
                                    <strong>To flash firmware:</strong>{' '}
                                    Disconnect the device, hold the{' '}
                                    <strong>BOOT</strong> button, reconnect via
                                    USB, then release the button.
                                </div>
                            )}
                        </div>
                    }
                    showCloseBtn={true}
                    handleDialogModalClose={() => {
                        setShowCustomFirmwarePrompt(false)
                        setPendingNavigation(null)
                    }}
                    optionsToSelect={[
                        {
                            text: 'Flash Firmware',
                            do: () => {
                                setShowCustomFirmwarePrompt(false)
                                setPendingNavigation(null)
                                localStorage.setItem(
                                    'firmwareUpdateConsent',
                                    'true'
                                )
                                history.push('/deviceSelection')
                            },
                        },
                        ...(isMicroPythonFlashed
                            ? [
                                  {
                                      text: 'Download from Website',
                                      do: () => {
                                          setShowCustomFirmwarePrompt(false)
                                          window.open(
                                              'https://firmware.plode.org/',
                                              '_blank'
                                          )
                                      },
                                  },
                              ]
                            : []),
                        {
                            text: 'Continue',
                            do: () => {
                                setShowCustomFirmwarePrompt(false)
                                if (pendingNavigation) {
                                    pendingNavigation()
                                    setPendingNavigation(null)
                                }
                            },
                        },
                    ]}
                />
                <MainHeader
                    title={languageWords[languageName]?.Code || 'Code'}
                    titlePosition="left"
                    help_btnPosition="right"
                    helper={<VisualPrgm />}
                    isGoBack={false}
                    goBack={() => {
                        setSlideDirection(true)
                        sessionStorage.setItem('slideDirection', true)
                        // If we reached /code through the "advanced" button in
                        // KitMenu, selectionBackRoute is set to '/kitMenu' so we
                        // go back there. Otherwise fall back to the normal flow.
                        if (
                            props.navigation?.selectionBackRoute === '/kitMenu'
                        ) {
                            history.push(props.navigation.selectionBackRoute)
                        } else {
                            history.push('/selection')
                        }
                    }}
                    showAiBtn={true}
                />
                <div
                    className={`${
                        slideDirection === 'true' ? 'slide-right' : ''
                    } `}
                    style={{ position: 'relative' }}
                >
                    <p className="VP-txt-Heading">
                        {languageWords[languageName]?.VisualProgramming ||
                            'Visual Programming'}
                    </p>

                    <hr className="VP-hr" />

                    <p className="VP-txt-Heading2">
                        {languageWords[languageName]?.ScriptProgramming ||
                            'Script Programming'}
                    </p>

                    <hr className="VP-hr2" />
                    <div>
                        {/* ITEM - 1 */}

                        {/* <Link to="/flow"> */}
                        <FeatureGate
                            enabled={isCodingFeatureEnabled(
                                'code',
                                'flowchart',
                                brandDeviceKey
                            )}
                            onDisabledClick={handleDisabledClick}
                        >
                            <div
                                className="VP-flowchartbased vp-item1"
                                style={item1Styl}
                                onClick={handelFlowChartClick}
                                title={customFirmwareTooltip}
                            >
                                <div
                                    className="VP-sub1"
                                    style={{
                                        cursor: [
                                            'Hexapod',
                                            'Roboki',
                                            'Klaw',
                                            'Atr',
                                            'Toki',
                                            'Poki',
                                            'Moki',
                                            'Autoki',
                                            'woofKit',
                                        ].includes(device)
                                            ? 'default'
                                            : 'pointer',
                                    }}
                                >
                                    <p className="VP-sub-txt">
                                        {languageWords[languageName]
                                            ?.FlowchartBased ||
                                            'Flowchart \nBased'}
                                    </p>
                                </div>
                            </div>
                        </FeatureGate>
                        {/* </Link> */}

                        {/* ITEM - 2 */}
                        <FeatureGate
                            enabled={isCodingFeatureEnabled(
                                'code',
                                'project',
                                brandDeviceKey
                            )}
                            onDisabledClick={handleDisabledClick}
                        >
                            <div
                                // to="/code/project"

                                onClick={() => {
                                    projectBaseHandelClick()
                                }}
                                title={customFirmwareTooltip}
                            >
                                <div
                                    className="VP-programbased vp-item2"
                                    style={item2Styl}
                                >
                                    <div
                                        className="VP-sub2"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <p className="VP-sub2-txt">
                                            {languageWords[languageName]
                                                ?.ProjectBased ||
                                                'Project \nBased'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </FeatureGate>

                        {/* Item 3*/}
                        <FeatureGate
                            enabled={isCodingFeatureEnabled(
                                'code',
                                'block',
                                brandDeviceKey
                            )}
                            onDisabledClick={handleDisabledClick}
                        >
                            <div
                                className="VP-blockbased vp-item3"
                                style={item3Styl}
                                onClick={() => {
                                    blockbasedbtn()
                                }}
                                title={customFirmwareTooltip}
                            >
                                <div
                                    className="VP-sub3"
                                    style={{
                                        cursor:
                                            [
                                                'Klaw',
                                                'Atr',
                                                'Toki',
                                                'Poki',
                                                'Moki',
                                                'Autoki',
                                            ].includes(device) ||
                                            (device === 'Hexapod' &&
                                                deviceVersion?.[0] === '3')
                                                ? 'default'
                                                : 'pointer',
                                    }}
                                >
                                    <p className="VP-sub3-txt">
                                        {languageWords[languageName]
                                            ?.BlockBased || 'Block \nBased'}
                                    </p>
                                </div>
                            </div>
                        </FeatureGate>
                    </div>

                    <div
                        style={{
                            backgroundColor: '#8ACDEA',
                            opacity: '10%',
                        }}
                    ></div>
                    {/* Item 4 */}
                    <FeatureGate
                        enabled={isCodingFeatureEnabled(
                            'code',
                            'c',
                            brandDeviceKey
                        )}
                        onDisabledClick={handleDisabledClick}
                    >
                        <div
                            className="VP-CCoding vp-item4"
                            style={item4Styl}
                            onClick={handelCcodingClick}
                            title={
                                isMicroPythonFlashed
                                    ? customFirmwareTooltip
                                    : undefined
                            }
                        >
                            <div className="VP-sub4">
                                <p className="VP-sub4-txt">
                                    {languageWords[languageName]?.CCoding ||
                                        'C \nCoding'}
                                </p>
                            </div>
                        </div>
                    </FeatureGate>

                    {/* Item 5 */}
                    <FeatureGate
                        enabled={isCodingFeatureEnabled(
                            'code',
                            'python',
                            brandDeviceKey
                        )}
                        onDisabledClick={handleDisabledClick}
                    >
                        <div
                            className="VP-pythoncodingbutton vp-item5"
                            style={item5Styl}
                            onClick={handlePythonClick}
                            title={customFirmwareTooltip}
                        >
                            <div className="VP-sub5">
                                <p className="VP-sub5-txt">
                                    {languageWords[languageName]
                                        ?.PythonCoding || 'Python \nCoding'}
                                </p>
                            </div>
                        </div>
                    </FeatureGate>
                </div>
            </div>

            {show_tost_text.isShow && (
                <p className="comingSoon_text">{show_tost_text.text}</p>
            )}
            {/* {isShow_cServerDown_text && (
                <p className="comingSoon_text" style={{ left: '45%' }}>
                    C server is down now.
                </p>
            )} */}

            {/* <div id="popup-text">
                update the PeeCee firmware to 1.0.04 version to enable python
                coding
            </div> */}
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}

export default connect(mapStateToProps)(VisualProgram)
